"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SETTING_SV_ID = void 0;
exports.apiGetSearchChannelIds = apiGetSearchChannelIds;
exports.apiGetStaticAgentList = apiGetStaticAgentList;
exports.getCacheStaticTableInfo_new = exports.getCacheStaticTableInfo = exports.apiGetStaticTableInfo_new = exports.apiGetStaticTableInfo = void 0;
exports.getManyStaticTableInfo = getManyStaticTableInfo;
exports.getOtcCoinRate = getOtcCoinRate;

require("core-js/modules/es.object.values.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.set.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.json.stringify.js");

require("regenerator-runtime/runtime.js");

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _toConsumableArray2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _api = _interopRequireDefault(require("@/assets/js/api"));

var _global = _interopRequireDefault(require("@/assets/js/global.js"));

var _stationSetting = require("@/assets/js/stationSetting");

// const { VUE_APP_UCENTER } = process.env;
var Btn = false;
var changeSvId = []; //静态表设置

var SETTING_SV_ID = {
  static_coin: 1,
  static_sms_country: 2,
  otc_static_coin: 3,
  static_currency: 7,
  static_item_v2: 13,
  static_exchange_limit: 14,
  sotc_static_payment: 22,
  swap_static_symbol: 26,
  static_assets_type: 27,
  //资产记录静态配置表
  // static_item_permission: 38, //币种权限表
  sotc_static_guarantee_type: 42,
  // 用户卖U包赔时间类型
  stock_static_symbol: 46,
  // 股票
  contract_static_symbol: 49,
  // U本位合约
  static_symbol: 55,
  //币币交易对
  static_chain: 56,
  //区块地址
  static_coin_chain: 57,
  //币币多链配置表
  futures_static_symbol: 58,
  //币本位合约
  static_rebate_type: 59,
  //static_rebate_type表
  sotc_static_item: 63,
  //匿名OTC数字货币表表
  // static_otc_third_payment: 64, //第三方OTC 支付配置
  static_otc_third_payment_new: 69,
  //第三方OTC 支付配置 新变更
  // static_third_payment: 65, //第三方 OTC 支付方式静态配置
  static_third_payment: 68,
  //第三方 OTC 支付方式静态配置 新变更
  static_mateverse_trend_coin_list_future: 69,
  //元宇宙配置表
  static_mateverse_trend_coin_list_spot: 70,
  //元宇宙配置表
  main_geetest_captcha_config: 75 //极验证配置数据

}; //获取所有静态表版本号

exports.SETTING_SV_ID = SETTING_SV_ID;

function getStaticTableList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: "".concat(_stationSetting.VUE_APP_UCENTER, "/Settings/getStaticTableList"),
    data: data
  });
}

function getChangeStaticTable() {
  return _getChangeStaticTable.apply(this, arguments);
} //获取静态表信息


function _getChangeStaticTable() {
  _getChangeStaticTable = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
    var _yield$getStaticTable, status, data, result, resultParse, key, index;

    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            changeSvId = [];
            _context5.next = 3;
            return getStaticTableList();

          case 3:
            _yield$getStaticTable = _context5.sent;
            status = _yield$getStaticTable.status;
            data = _yield$getStaticTable.data;
            result = localStorage.getItem("staticTableVersion");

            if (data && data.length != 0 && result && result != "[object Object]") {
              resultParse = result && JSON.parse(result);

              for (key in resultParse) {
                for (index in data) {
                  if (resultParse[key].sv_id == data[index].sv_id && data[index].version > resultParse[key].version) {
                    changeSvId.push(resultParse[key].sv_id);
                  }
                }
              }
            }

            localStorage.setItem("staticTableVersion", JSON.stringify(data));
            return _context5.abrupt("return", changeSvId);

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getChangeStaticTable.apply(this, arguments);
}

var apiGetStaticTableInfo_new = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee(sv_id) {
    var result;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return getCacheStaticTableInfo(sv_id);

          case 2:
            result = _context.sent;
            return _context.abrupt("return", {
              data: result,
              status: 200
            });

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function apiGetStaticTableInfo_new(_x) {
    return _ref.apply(this, arguments);
  };
}(); //获取静态表信息


exports.apiGetStaticTableInfo_new = apiGetStaticTableInfo_new;

var apiGetStaticTableInfo = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(sv_id) {
    var result;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return getCacheStaticTableInfo(sv_id);

          case 2:
            result = _context2.sent;
            return _context2.abrupt("return", {
              data: result,
              status: 200
            });

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function apiGetStaticTableInfo(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

exports.apiGetStaticTableInfo = apiGetStaticTableInfo;
var VERSION = 1; //缓存静态表,防止一个页面多次请求

var getCacheStaticTableInfo_new = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(sv_id) {
    var result, changeStaticTableID, settingList, sv_ids, localIdsTemp, resultIDS, res, _res, data;

    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            result = localStorage.getItem("settingList") ? JSON.parse(localStorage.getItem("settingList")) : "";

            if (!result) {
              localStorage.setItem("settingList", "{}");
            }

            changeStaticTableID = [];

            if (Date.parse(new Date()) / 1000 - parseInt(localStorage.getItem("changeStaticTableTime") ? localStorage.getItem("changeStaticTableTime") : 0) > 60 * 5) {
              localStorage.setItem("changeStaticTableTime", Date.parse(new Date()) / 1000);
              changeStaticTableID = getChangeStaticTable();
            }

            settingList = {};
            sv_ids = [];

            if (!result) {
              sv_ids = Object.values(SETTING_SV_ID);
              sv_ids.push(sv_id);
              sv_ids = Array.from(new Set(sv_ids));
            } else {
              localIdsTemp = Object.keys(result); // let settingIdsTemp = Object.values(SETTING_SV_ID);

              resultIDS = Array.from(new Set([].concat((0, _toConsumableArray2.default)(localIdsTemp))));

              if (changeStaticTableID.includes(sv_id) || !resultIDS.includes(sv_id + "")) {
                sv_ids.push(sv_id);
              }
            }

            res = {};

            if (!(sv_ids && sv_ids.length > 0)) {
              _context3.next = 12;
              break;
            }

            _context3.next = 11;
            return getManyStaticTableInfo({
              sv_ids: sv_ids.join(",")
            });

          case 11:
            res = _context3.sent;

          case 12:
            _res = res, data = _res.data;

            if (!data) {
              data = {};
            }

            if (!result) {
              _global.default.settingList = settingList = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, JSON.parse(JSON.stringify(_global.default.settingList))), JSON.parse(JSON.stringify(data)));
            } else {
              _global.default.settingList = settingList = (0, _objectSpread2.default)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, JSON.parse(JSON.stringify(_global.default.settingList))), JSON.parse(JSON.stringify(result))), JSON.parse(JSON.stringify(data)));
            }

            localStorage.setItem("settingList", JSON.stringify(settingList));
            return _context3.abrupt("return", settingList[sv_id]);

          case 17:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function getCacheStaticTableInfo_new(_x3) {
    return _ref3.apply(this, arguments);
  };
}(); //缓存静态表,防止一个页面多次请求


exports.getCacheStaticTableInfo_new = getCacheStaticTableInfo_new;

var getCacheStaticTableInfo = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(sv_id) {
    var result, version, LastTime, nowTime, settingList, settingListNew, tempObjects, changeSvidArray, _timestamp, noChangeList, oldSettingList, sv_ids, sv_no_ids, k, _i, _sv_no_ids, svid, tempList, res, _res2, data, timestamp;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            //先查缓存
            result = localStorage.getItem("settingList");
            version = localStorage.getItem("settingListVersion");
            LastTime = localStorage.getItem("webSettingLastTime");
            nowTime = Date.parse(new Date()) / 1000;
            tempObjects = result && result != "{}" && result != "undefined" && result != "[object Object]" && JSON.parse(result); //获取需要更新的静态表ID
            //若已存在SETTINGLIST，并存储静态表版本信息，则在新加静态表号时会出现读出UNDEFIND新静态表的情况，以下为判断此种情况

            changeSvidArray = [];

            if (tempObjects && !tempObjects[sv_id]) {
              changeSvidArray.push(sv_id);
            }

            if (!(result && result != "{}" && result != "undefined" && result != "[object Object]" && version == VERSION && nowTime - LastTime > 60 * 1 && tempObjects[sv_id])) {
              _context4.next = 16;
              break;
            }

            _timestamp = Date.parse(new Date()) / 1000;
            localStorage.setItem("webSettingLastTime", _timestamp); // 需要更新
            // getStaticTableList();

            console.log("更新靜態表");
            _context4.next = 13;
            return getChangeStaticTable();

          case 13:
            changeSvidArray = _context4.sent;
            _context4.next = 22;
            break;

          case 16:
            if (!(result && result != "{}" && result != "undefined" && result != "[object Object]" && version == VERSION && tempObjects[sv_id])) {
              _context4.next = 21;
              break;
            }

            settingList = JSON.parse(result);
            return _context4.abrupt("return", settingList[sv_id]);

          case 21:
            if (!result || result == "{}" || result == "undefined" || result == "[object Object]") {
              changeSvidArray = Object.values(SETTING_SV_ID);
            }

          case 22:
            //不需要更新的静态表对象数组
            noChangeList = {}; //原先静态表对象

            oldSettingList = JSON.parse(result); //需要更新的静态表ID

            sv_ids = []; //不需要更新的静态表ID

            sv_no_ids = []; // for (var k in SETTING_SV_ID) {
            //   if (changeSvidArray.includes(SETTING_SV_ID[k])) {
            //     sv_ids.push(SETTING_SV_ID[k]);
            //   } else {
            //     sv_no_ids.push(SETTING_SV_ID[k]);
            //   }
            // }

            for (k in SETTING_SV_ID) {
              if (!changeSvidArray.includes(SETTING_SV_ID[k])) {
                sv_no_ids.push(SETTING_SV_ID[k]);
              }
            }

            sv_ids = changeSvidArray;

            for (_i = 0, _sv_no_ids = sv_no_ids; _i < _sv_no_ids.length; _i++) {
              svid = _sv_no_ids[_i];
              noChangeList[svid] = oldSettingList[svid];
            }

            if (!Btn) {
              _context4.next = 33;
              break;
            }

            tempList = localStorage.getItem("settingList", JSON.stringify(settingList));

            if (!tempList) {
              _context4.next = 33;
              break;
            }

            return _context4.abrupt("return", tempList[sv_id]);

          case 33:
            if (!(changeSvidArray && changeSvidArray.length == 0 && sv_ids.length == 0)) {
              _context4.next = 35;
              break;
            }

            return _context4.abrupt("return", oldSettingList[sv_id]);

          case 35:
            //如果没有缓存
            res = {};

            if (!(sv_ids && sv_ids.length > 0)) {
              _context4.next = 40;
              break;
            }

            _context4.next = 39;
            return getManyStaticTableInfo({
              sv_ids: sv_ids.join(",")
            });

          case 39:
            res = _context4.sent;

          case 40:
            _res2 = res, data = _res2.data;

            if (data) {
              _context4.next = 43;
              break;
            }

            return _context4.abrupt("return", {});

          case 43:
            settingListNew = data;
            settingList = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, noChangeList), settingListNew);
            localStorage.setItem("settingList", JSON.stringify(settingList));
            localStorage.setItem("settingListVersion", VERSION);
            timestamp = Date.parse(new Date()) / 1000;
            localStorage.setItem("webSettingLastTime", timestamp);
            Btn = false; // localStorage.setItem("webSettingListTime", timestamp);

            return _context4.abrupt("return", settingList[sv_id]);

          case 51:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function getCacheStaticTableInfo(_x4) {
    return _ref4.apply(this, arguments);
  };
}(); //获取多个静态表信息  params =  1,2,3,4,5,6,


exports.getCacheStaticTableInfo = getCacheStaticTableInfo;

function getManyStaticTableInfo() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  Btn = true;
  return (0, _api.default)({
    url: "".concat(_stationSetting.VUE_APP_UCENTER, "/Settings/getStaticTableInfoList"),
    data: data
  });
} // 获取币种汇率


function getOtcCoinRate() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: "".concat(_stationSetting.VUE_APP_UCENTER, "/Settings/otcCoinRate"),
    data: data
  });
} // 获取产品通道列表


function apiGetStaticAgentList() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: "".concat(_stationSetting.VUE_APP_UCENTER, "/Settings/getStaticAgentList"),
    data: data
  });
} // 商户搜索条件


function apiGetSearchChannelIds() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _api.default)({
    url: "".concat(_stationSetting.VUE_APP_UCENTER, "/UCenter/ChannelAgent/getSearchChannelIds"),
    data: data
  });
}